import React from 'react';
import { Typography, Card, Row, Col } from 'antd';

// import SectionHeader from '../components/SectionHeader';

const DIRECTOR_BOARD = [
    {
        name: 'Dr. Chanakya Wijeratne',
        desc: 'Chief Executive Officer',
        img: '',
    },
    // {
    //     name: 'Dr. Glenfrey Bernil De Mel',
    //     desc: 'Chief Operating Officer',
    //     img: '',
    // },
    // {
    //     name: 'Mrs. Priyatha Nanayakkara',
    //     desc: 'Chief Administrative Officer',
    //     img: '',
    // },
    {
        name: 'Ms. Samantha Lakmini Ariyaratna',
        desc: 'Director of Operations',
        img: '',
    },
];

const SLOMFPeople = (): JSX.Element => {
    return (
        <>
            <Typography.Title level={3}>People</Typography.Title>

            {/* <SectionHeader>Advisory Board</SectionHeader>
            <Row gutter={[16, 16]}>
                {ADVISORY_BOARD.map(member => {
                    return (
                        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} key={member.name}>
                            <Card style={{ height: '100%' }}>
                                <Typography.Title level={5}>{member.name}</Typography.Title>
                                <Typography.Text type="secondary">{member.desc}</Typography.Text>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
            <br />
            <SectionHeader>Director Board</SectionHeader> */}
            <Row gutter={[16, 16]}>
                {DIRECTOR_BOARD.map(member => {
                    return (
                        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} key={member.name}>
                            <Card style={{ height: '100%' }}>
                                <Typography.Title level={5}>{member.name}</Typography.Title>
                                <Typography.Text type="secondary">{member.desc}</Typography.Text>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
            {/* <hr />
            <p>
                <a href="https://www.vecteezy.com/free-vector/default-male-avatar">
                    Default Male Avatar Vectors by Vecteezy
                </a>
            </p> */}
        </>
    );
};

export default SLOMFPeople;
